import React from "react";
import { useTrail, animated } from "react-spring";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper/";
import media from "styled-media-query";
const Wrapper = styled.div`
	margin: 0;
	width: 100%;
	${media.greaterThan(breakpoints.mobile)`
		margin: ${({ isVideo, isMixedContent }) =>
			isVideo && !isMixedContent ? "0 10px 0 0" : "0 0 0 20px"};
        
		width: ${({ isVideo, isMixedContent }) =>
			isVideo && !isMixedContent ? "calc(50% - 30px)" : "calc(33% - 20px)"};

`}
`;
export const SearchAnimations = ({
	items,
	itemProp,
	isMixedContent,
	loading = false,
	children,
	mass = 10,
	tension = 1500,
	friction = 170,
	wrapperStyle,
}) => {
	const config = { mass: mass, tension: tension, friction: friction };
	const trail = useTrail(items.length, {
		config,
		opacity: !loading ? 1 : 0,
		x: 0,
		from: { opacity: 0, x: 40 },
	});

	const renderChildren = (index) =>
		React.Children.map(children, (child) => {
			return React.cloneElement(
				child,
				itemProp
					? { [itemProp]: items[index], key: index, first: index == 0 }
					: { ...items[index], key: index, first: index == 0 }
			);
		});

	return trail.map(({ x, ...rest }, index) => {
		let isVideo = false;
		if (items.length > 0) {
			isVideo =
				items[index].Type != undefined
					? items[index].Type == "videopage"
						? true
						: false
					: false;
		}

		return (
			<Wrapper isMixedContent={isMixedContent} key={index} isVideo={isVideo}>
				<animated.div
					style={{
						...rest,
						transform: x.interpolate((x) => `translate3d(0,${x}px,0)`),
					}}
				>
					{renderChildren(index)}
				</animated.div>
			</Wrapper>
		);
	});
};
